import script from "./1.vue?vue&type=script&setup=true&lang=js"
export * from "./1.vue?vue&type=script&setup=true&lang=js"

import "./1.vue?vue&type=style&index=0&id=0d51c172&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d51c172"]])

export default __exports__